import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.element.style.cursor = "pointer"
    this.boundVisit = this.visit.bind(this)
    this.element.addEventListener("click", this.boundVisit)
  }

  disconnect() {
    this.element.removeEventListener("click", this.boundVisit)
  }

  visit(event) {
    if (event.metaKey || event.ctrlKey) {
      window.open(this.urlValue, '_blank')
    } else if (window.Turbo) {
      Turbo.visit(this.urlValue)
    } else {
      window.location.href = this.urlValue
    }
  }
}
